export default __webpack_public_path__ + "static/media/ESG Fintech Article - MiddleMarch.22cad938.pdf";